import React from 'react'
import {
    ButtonPagination,
    ContentPaginationSection,
    Image,
    Pagination,
} from './styles'
import NavigateBefore from 'src/assets/Blog/navigatebefore.avif'
import NavigateNext from 'src/assets/Blog/navigatenext.avif'
interface ContentPaginationProps {
    currentPage: number
    totalPages: number
    handlePreviousPage: () => void
    handleNextPage: () => void
    setCurrentPage: React.Dispatch<React.SetStateAction<number>>
}

export const ContentPagination = ({
    currentPage,
    totalPages,
    handlePreviousPage,
    handleNextPage,
    setCurrentPage,
}: ContentPaginationProps) => {
    let startPage = currentPage - 1
    let endPage = startPage + 2
    if (startPage < 1) {
        startPage = 1
        endPage = Math.min(totalPages, 3)
    } else if (endPage > totalPages) {
        endPage = totalPages
        startPage = Math.max(1, endPage - 2)
    }
    return (
        <ContentPaginationSection
            marginTop={['xmedium', 'xmedium', 'xmedium', 'titlle']}
        >
            {currentPage > 1 && (
                <ButtonPagination
                    onClick={handlePreviousPage}
                    className={'button'}
                >
                    <Image src={NavigateBefore} />
                </ButtonPagination>
            )}

            {Array.from(
                { length: endPage - startPage + 1 },
                (_, index) => startPage + index
            ).map((pageNumber) => (
                <Pagination
                    key={pageNumber}
                    onClick={() => setCurrentPage(pageNumber)}
                    isActive={pageNumber === currentPage}
                >
                    {pageNumber}
                </Pagination>
            ))}

            {currentPage < totalPages && (
                <ButtonPagination onClick={handleNextPage} className={'button'}>
                    <Image src={NavigateNext} />
                </ButtonPagination>
            )}
        </ContentPaginationSection>
    )
}
